export default __webpack_public_path__ + "static/media/hht2_direction_speakingpractice_02.3cc1d40a.png";